(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("enableGamification", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/gamification/enableGamificationView.html",
            controller: ["gamificationResource", "$rootScope", "$state", "messageService", "_", EnableGamificationCtrl],
            controllerAs: "vm"
        };
        function EnableGamificationCtrl(gamificationResource, $rootScope, $state, messageService, _) {
            var vm = this;
            vm.saving = false;
            vm.loading = true;
            gamificationResource.getGamificationViewModel(function (data) {
                vm.gamification = data;
                vm.loading = false;
            });
            vm.findSystem = function (name) {
                return _.find(vm.gamification.systems, function (sys) { return sys.name === name; });
            };
            vm.disableSystem = function (name) {
                vm.saving = true;
                var system = vm.findSystem(name);
                gamificationResource.disableSystem({ name: system.name }, function () {
                    system.enabled = false;
                    if (_.every(vm.gamification.systems, function (sys) { return !sys.enabled; }))
                        vm.gamification.enabled = false;
                    messageService.success("gamification.systemDisabled.success");
                    $rootScope.$broadcast("reloadTenantSettings");
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            vm.enableSystem = function (name) {
                vm.saving = true;
                var system = vm.findSystem(name);
                gamificationResource.enableSystem({ name: system.name }, function () {
                    system.enabled = true;
                    messageService.success("gamification.systemEnabled.success");
                    $rootScope.$broadcast("reloadTenantSettings");
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            vm.onChangeGamification = function (value) {
                if (value)
                    vm.enableGamification();
                else
                    vm.disableGamification();
            };
            vm.disableGamification = function () {
                vm.saving = true;
                gamificationResource.disable(function () {
                    vm.gamification.enabled = false;
                    $rootScope.$broadcast("reloadTenantSettings");
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            vm.enableGamification = function () {
                vm.saving = true;
                gamificationResource.enable(function (data) {
                    vm.gamification = data;
                    messageService.success("gamification.enabled.success");
                    $rootScope.$broadcast("reloadTenantSettings");
                    vm.saving = false;
                }, function (error) {
                    messageService.error(error);
                    vm.saving = false;
                });
            };
            vm.configureSystem = function (name) {
                switch (name) {
                    case "Point System":
                        $state.go("main.gamification.pointSystem");
                        break;
                    case "Badge System":
                        $state.go("main.gamification.badgeSystem");
                        break;
                    case "Tier System":
                        $state.go("main.gamification.tierSystem");
                        break;
                    case "Leaderboard System":
                        $state.go("main.gamification.leaderboardSystem");
                        break;
                    default:
                        $state.go("main.notFound");
                }
            };
        }
    });
})();
